import {
  Collapse,
  createStyles,
  Grid,
  IconButton,
  makeStyles,
  Theme,
  Tooltip,
  Typography,
} from '@material-ui/core';
import {
  Delete,
  Edit,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Lock
} from '@material-ui/icons';
import { FuncaoInternaParticipante, FuncaoParticipante, GrupoAcesso, Perfil, UsuarioModelResponse } from 'common/genericTypes';
import { SmSpace, TextButton } from 'm2m.components';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { addCpfCnpjMask } from 'utils/mask';

const useStyles = () =>
  makeStyles((theme: Theme) => {
    return createStyles({
      icon: {
        marginRight: 10,
      },
      wrapTxt: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      textButton: {
        padding: '0 0 0 0',
        marginRight: '10px',
        borderBottom: `1px solid ${theme.palette.primary.main}`,
        borderRadius: 0,
      },
    });
  });

interface UsuarioListItemProps {
  usuario: UsuarioModelResponse;
  onEdit: (usuario: UsuarioModelResponse) => void;
  onDelete: (usuario: UsuarioModelResponse) => void;
  onDesbloquear: (usuario: UsuarioModelResponse) => void;
}

type Props = UsuarioListItemProps;

export const UsuarioListItem: React.FC<Props> = (props) => {
  const {
    usuario,
    onEdit,
    onDelete,
    onDesbloquear
  } = props;
  const classes = useStyles()();
  const [openDetails, setOpenDetails] = useState<boolean>(false);

  const usuarioPerfil = useSelector((state: RootState) => state.auth.usuario.participante.perfil);
  const isUsuarioGestaoAcessos = useSelector((state: RootState) => state.auth.usuario.grupoAcesso === GrupoAcesso.GestaoAcessos);
  const gridSm = 2;
  return (
    <div style={{ border: '1px solid #E5E5E5', borderRadius: 8, marginBottom: 10 }}>
      <div style={{ padding: 10 }}>
        <Grid container alignItems="center" justifyContent='space-between' spacing={4} >
          <Grid item sm={gridSm}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Tooltip title="Nome do usuário" placement='top-start'>
                <Typography variant="body2" className={classes.wrapTxt}>
                  {usuario.nome}
                </Typography>
              </Tooltip>
            </div>
          </Grid>
          <Grid item sm={gridSm}>
            <Tooltip title="Email" placement='top-start'>
              <Typography className={classes.wrapTxt} variant="body2">
                {usuario.email}
              </Typography>
            </Tooltip>
          </Grid>
          <Grid item sm={gridSm}>
            <Tooltip title="Status" placement='top-start'>
              <Typography className={classes.wrapTxt} variant="body2">
                {usuario.ativo ? 'Ativo' : 'Inativo'}
              </Typography>
            </Tooltip>
          </Grid>
          <Grid item sm={gridSm}>
            <Tooltip title="Participante" placement='top-start'>
                <Typography className={classes.wrapTxt} variant="body2">
                  {usuario.participanteFuncoes[0]?.razaoSocialParticipante ?? ''}
                </Typography>
            </Tooltip>
          </Grid>
          <Grid item >
            <Grid container justifyContent='space-between' >
              <Grid item sm={gridSm} style={{ display: 'flex'}} >
                  <Tooltip title="Editar" placement='top-start'>
                      <IconButton aria-label="edit row" size="small" onClick={() => onEdit(usuario)} >
                        <Edit fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Deletar" placement='top-start'>
                      <IconButton aria-label="delete row" size="small" onClick={() => onDelete(usuario)} >
                        <Delete fontSize="small" />
                      </IconButton>
                    </Tooltip>             
                {usuario.suspenso && <Tooltip title="Desbloquear" placement='top-start'>
                  <IconButton aria-label="unlock row" size="small" onClick={() => onDesbloquear(usuario)} disabled={usuarioPerfil === Perfil.Leitura}>
                    <Lock fontSize="small" />
                  </IconButton>
                </Tooltip>}
              </Grid>
              <Grid item>
                <IconButton aria-label="expand row" size="small" onClick={() => setOpenDetails(!openDetails)}>
                  {openDetails ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Collapse in={openDetails} timeout="auto" unmountOnExit style={{ backgroundColor: '#F6F6F9', padding: 20 }}>
        {usuario.participanteFuncoes.map(pf => 
        <Grid key={pf.participanteFuncaoId} container spacing={2}>
          <Grid item sm={3}>
            <Typography variant="body1">{'Participante:'}</Typography>
            <Typography variant="body2">{pf.razaoSocialParticipante}</Typography>
          </Grid>
          <Grid item sm={3}>
            {pf.funcao !== FuncaoInternaParticipante.Depositaria ? <>
              <Typography variant="body1">{'CNPJ Participante:'}</Typography>
              <Typography variant="body2">{addCpfCnpjMask(pf.cnpjParticipante)}</Typography>
            </> : <>
              <Typography variant="body1">{'Grupo de Acesso:'}</Typography>
              <Typography variant="body2">{usuario.grupoAcesso}</Typography>
            </>}
          </Grid>
          <Grid item sm={3}>
            <Typography variant="body1">{'Função:'}</Typography>
            <Typography variant="body2">{pf.funcao}</Typography>
          </Grid>
          <Grid item sm={3}>
            <Typography variant="body1">{'Perfil de Acesso:'}</Typography>
            <Typography variant="body2">{pf.perfil}</Typography>
          </Grid>
        </Grid>)}
      </Collapse>
    </div>
  );
};
